import type { FaireThemeEntity } from "../../entity_types/theme";

export const pineapple_perfect_tea_towels: FaireThemeEntity = {
  token: "pineapple-perfect-tea-towels",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Pineapple-Perfect Tea Towels",
  description: "Giftable kitchen textiles with tropical prints",
  bgColor: "#D4EBD4",
  tileBgColor: "#827525",
  productTokens: [
    "p_mkd8y8cb7j",
    "p_mmacpu3tmw",
    "p_knwzzhk4mw",
    "p_2abc3hengk",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
